import React from 'react';
import { Button, Result } from 'antd';


export const PageError = ({name:status,message,onClick,...other})=><Result
    status={status||"404"}
    title={status||"404"}
    subTitle={message||"Sorry, the page you visited does not exist."}
    extra={<Button type="primary" onClick={onClick}>Back Home</Button>}
  />;
  
export default ({error={}}) => (
<Result
    status={"403"}
    title={error?.name??"Error"}      
    subTitle={error?.message??""}
  />
);
